
import React from "react";
import InterviewQuestions from '../Components/Dashboard/Resource-Center/InterviewQuestions';
import {
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import SessionTimeoutRedirect from '../Components/Common/SessionTimeoutRedirect'
const AuthInterviewQuestions = () => {
   const useAuth=()=>{
    const user=localStorage.getItem('user_id')
    const token = document.cookie.replace(/(?:(?:^|.*;\s*)token\s*=\s*([^;]*).*$)|^.*$/, '$1');

    if(token){
      return true
    } else {
      localStorage.clear()
      return false
    }
  }
  const auth = useAuth();
  return auth ? <InterviewQuestions /> : <SessionTimeoutRedirect />
}
export default AuthInterviewQuestions;


